import { render, staticRenderFns } from "./anamneseDashboardSettingsPageDialog.vue?vue&type=template&id=668bf562&scoped=true"
import script from "./anamneseDashboardSettingsPageDialog.vue?vue&type=script&lang=js"
export * from "./anamneseDashboardSettingsPageDialog.vue?vue&type=script&lang=js"
import style0 from "./anamneseDashboardSettingsPageDialog.vue?vue&type=style&index=0&id=668bf562&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668bf562",
  null
  
)

export default component.exports